import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import QualificationComponent from './QualificationComponent';
import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';

import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import QualificationAccordionSummary from './QualificationAccordionSummary';

import RepresentantGestionAutocomplete from 'components/Shared/RepresentantGestionAutocomplete';
import DepotGestionSelect from 'components/Shared/DepotGestionSelect';
import AdresseForm from 'components/Shared/AdresseForm';
import { AdresseFormModes } from 'components/Shared/AdresseForm';

import { GarantieType } from 'constants.js';

const localisationLabel = "Où se trouve physiquement le produit  ?";
const localisations = [
    "Dans un magasin",
    "Remis à un ATC",
    "Chez le client",
    "Autre"
];


const situationLabel = "Sélectionner la situation de l'article: ";
const situations = [
    "Le produit est démontable",
    "Le produit n'est pas déplaçable"
];


const enlevementLabel = "Demande d'enlèvement: ";
const enlevements = [
    "Par Foussier",
    "Par le fabricant"
];


const actionLabel = "Sélectionner l'action à mener: ";
const actions = [
    "Passage du fabricant pour situation",
    "Passage ATC",
    "Validation manager",
    "Demande d'information au chef produit",
];

const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1),
        width: '100%'
    },

    group: {
        margin: theme.spacing(1, 0)
    },
});

class LocalisationProduit extends QualificationComponent {


    constructor(props) {
        super(props);


        this.state = {
            ...this.state,
            [ReclamationQualificationDetailCodes.LocalisationProduit]: '',
            [ReclamationQualificationDetailCodes.LocalisationProduitAutreCommentaire]: '',
            [ReclamationQualificationDetailCodes.Depot]: this.props.reclamation.magasin ? this.props.reclamation.magasin.codeDepot : '',
            [ReclamationQualificationDetailCodes.Representant]: '',
            [ReclamationQualificationDetailCodes.SituationArticle]: '',
            [ReclamationQualificationDetailCodes.Enlevement]: '',
            [ReclamationQualificationDetailCodes.AdresseEnlevement]: '',
            [ReclamationQualificationDetailCodes.AdresseRetour]: '',
            [ReclamationQualificationDetailCodes.ActionAMener]: '',
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.LocalisationProduit,
            ReclamationQualificationDetailCodes.LocalisationProduitAutreCommentaire,
            ReclamationQualificationDetailCodes.Depot,
            ReclamationQualificationDetailCodes.Representant,
            ReclamationQualificationDetailCodes.SituationArticle,
            ReclamationQualificationDetailCodes.Enlevement,
            ReclamationQualificationDetailCodes.AdresseEnlevement,
            ReclamationQualificationDetailCodes.AdresseRetour,
            ReclamationQualificationDetailCodes.ActionAMener,
        ];
    }


    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");
    }



    getQualificationData(newState) {

        const { name/*, garantie */ } = this.props;

        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];


        // On vérifie que l'état est correct
        if (
            newState[ReclamationQualificationDetailCodes.LocalisationProduit] === ''
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '0' && newState[ReclamationQualificationDetailCodes.Depot] === '')
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '1' && newState[ReclamationQualificationDetailCodes.Representant] === '')
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '2' && newState[ReclamationQualificationDetailCodes.SituationArticle] === '')
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '2' && newState[ReclamationQualificationDetailCodes.SituationArticle] === '0' && newState[ReclamationQualificationDetailCodes.Enlevement] === '' /**/)
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '2' && newState[ReclamationQualificationDetailCodes.SituationArticle] === '0' && newState[ReclamationQualificationDetailCodes.AdresseEnlevement] === '' /**/)
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '2' && newState[ReclamationQualificationDetailCodes.SituationArticle] === '0' && newState[ReclamationQualificationDetailCodes.AdresseRetour] === '' /**/)
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '2' && newState[ReclamationQualificationDetailCodes.SituationArticle] === '1' && newState[ReclamationQualificationDetailCodes.ActionAMener] === '' /**/)
            || (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '3' && newState[ReclamationQualificationDetailCodes.LocalisationProduitAutreCommentaire] === '')
        ) {
            return {
                name: name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }



        let toAdd = [];

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.LocalisationProduit,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: localisationLabel,
            valeurInteger: newState[ReclamationQualificationDetailCodes.LocalisationProduit],
            valeurString: localisations[newState[ReclamationQualificationDetailCodes.LocalisationProduit]]
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.LocalisationProduit)

        if (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '0') {
            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.Depot,
                type: ReclamationQualificationDetailType.CodeDepot,
                libelle: localisations[0],
                valeurString: newState[ReclamationQualificationDetailCodes.Depot]
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.Depot)
        }
        if (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '1') {
            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.Representant,
                type: ReclamationQualificationDetailType.Texte,
                libelle: localisations[1],
                valeurString: newState[ReclamationQualificationDetailCodes.Representant]
            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.Representant)
        }
        if (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '2') {
            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.SituationArticle,
                type: ReclamationQualificationDetailType.ChoixSimple,
                libelle: situationLabel,
                valeurString: situations[newState[ReclamationQualificationDetailCodes.SituationArticle]],
                valeurInteger: newState[ReclamationQualificationDetailCodes.SituationArticle],

            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.SituationArticle);


            // le produit est démontable 
            if (newState[ReclamationQualificationDetailCodes.SituationArticle] === '0') {

                toAdd.push({
                    position: 0,
                    code: ReclamationQualificationDetailCodes.Enlevement,
                    type: ReclamationQualificationDetailType.ChoixSimple,
                    libelle: enlevementLabel,
                    valeurString: enlevements[newState[ReclamationQualificationDetailCodes.Enlevement]],
                    valeurInteger: newState[ReclamationQualificationDetailCodes.Enlevement],

                });
                toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.Enlevement);



                toAdd.push({
                    position: 0,
                    code: ReclamationQualificationDetailCodes.AdresseEnlevement,
                    type: ReclamationQualificationDetailType.Texte,
                    libelle: "Adresse d'enlèvement",
                    valeurString: newState[ReclamationQualificationDetailCodes.AdresseEnlevement],

                });
                toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.AdresseEnlevement);

                // Choix du fournisseur

                toAdd.push({
                    position: 0,
                    code: ReclamationQualificationDetailCodes.AdresseRetour,
                    type: ReclamationQualificationDetailType.Texte,
                    libelle: "Adresse de retour",
                    valeurString: newState[ReclamationQualificationDetailCodes.AdresseRetour],

                });
                toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.AdresseRetour);



            }
            // le produit n'est pas déplaçable
            if (newState[ReclamationQualificationDetailCodes.SituationArticle] === '1') {
                toAdd.push({
                    position: 0,
                    code: ReclamationQualificationDetailCodes.ActionAMener,
                    type: ReclamationQualificationDetailType.ChoixSimple,
                    libelle: actionLabel,
                    valeurString: actions[newState[ReclamationQualificationDetailCodes.ActionAMener]],
                    valeurInteger: newState[ReclamationQualificationDetailCodes.ActionAMener],

                });
                toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.ActionAMener);
            }

        }
        if (newState[ReclamationQualificationDetailCodes.LocalisationProduit] === '3') {

            toAdd.push({
                position: 0,
                code: ReclamationQualificationDetailCodes.LocalisationProduitAutreCommentaire,
                type: ReclamationQualificationDetailType.Texte,
                libelle: "Autre (commentaire)",
                valeurString: actions[newState[ReclamationQualificationDetailCodes.LocalisationProduitAutreCommentaire]]

            });
            toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.LocalisationProduitAutreCommentaire);
        }


        return {
            name: name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }


    render() {

        const { name, classes, garantie, adresseLivraison, adresseRetour, reclamation } = this.props;

        const localisationProduit = this.state[ReclamationQualificationDetailCodes.LocalisationProduit];
        const localisationProduitAutreCommentaire = this.state[ReclamationQualificationDetailCodes.localisationProduitAutreCommentaire];
        const situationArticle = this.state[ReclamationQualificationDetailCodes.SituationArticle];
        const enlevement = this.state[ReclamationQualificationDetailCodes.Enlevement];
        const actionAMener = this.state[ReclamationQualificationDetailCodes.ActionAMener];

        return (


            <Accordion id={name} defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Localisation du produit" />

                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>

                    
                    <p>Préconiser le retour en magasin pour éviter des litiges transports</p>

                    <div className={classes.row}>
                        <FormControl required className={classes.formControl}>
                            <FormLabel>{localisationLabel}</FormLabel>
                            <RadioGroup
                                name={ReclamationQualificationDetailCodes.LocalisationProduit}
                                className={classes.group}
                                value={localisationProduit}
                                onChange={this.handleChange}
                            >
                                {localisations.map((reponse, index) => (
                                    <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                ))}
                            </RadioGroup>
                        </FormControl>
                    </div>

                    {/* Magasin */}
                    {localisationProduit === '0' && (

                        <div className={classes.row}>
                            <DepotGestionSelect className={classes.formControl}
                                value={this.state[ReclamationQualificationDetailCodes.Depot]}
                                valueIsCode
                                onChange={(e, codeDepot) => {
                                    this.handleChange({
                                        target: {
                                            name: ReclamationQualificationDetailCodes.Depot,
                                            value: codeDepot
                                        }
                                    });
                                }}
                                magasinsSeulement
                                isRequired
                                autoFocus
                                label="Sélectionner un magasin :"
                                modeTri={1}
                                disabled={reclamation.magasin && reclamation.magasin.verrou}
                            />
                        </div>
                    )}

                    {/* Atc */}
                    {localisationProduit === '1' && (
                        <React.Fragment>
                            <RepresentantGestionAutocomplete
                                onChange={representant => {
                                    this.handleChange({
                                        target: {
                                            name: ReclamationQualificationDetailCodes.Representant,
                                            value: representant.nom
                                        }
                                    });
                                }}
                                required
                            />
                        </React.Fragment>
                    )}

                    {/* Client */}
                    {localisationProduit === '2' && (
                        <React.Fragment>


                            <div className={classes.row}>
                                <FormControl required className={classes.formControl}>
                                    <FormLabel>{situationLabel}</FormLabel>
                                    <RadioGroup
                                        name={ReclamationQualificationDetailCodes.SituationArticle}
                                        className={classes.group}
                                        value={situationArticle}
                                        onChange={this.handleChange}
                                    >
                                        {situations.map((reponse, index) => (
                                            <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </div>


                            {/* Le produit est démontable */}
                            {situationArticle === '0' && (
                                <React.Fragment>


                                    <div className={classes.row}>
                                        <FormControl required className={classes.formControl}>
                                            <AdresseForm
                                                label={"Adresse d'enlèvement"}
                                                adresse={adresseLivraison}
                                                onChange={(addr, addrStr) => this.handleChange({ target: { name: ReclamationQualificationDetailCodes.AdresseEnlevement, value: addrStr } })}
                                            />
                                        </FormControl>
                                    </div>

                                    <div className={classes.row}>
                                        <FormControl required className={classes.formControl}>
                                            <FormLabel>{enlevementLabel}</FormLabel>
                                            <RadioGroup
                                                name={ReclamationQualificationDetailCodes.Enlevement}
                                                className={classes.group}
                                                value={enlevement}
                                                onChange={this.handleChange}
                                            >
                                                {enlevements.map((reponse, index) => (
                                                    <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                                ))}
                                            </RadioGroup>
                                        </FormControl>
                                    </div>




                                    {/* Par Foussier */}
                                    {enlevement === '0' && (
                                        <React.Fragment>

                                            {garantie === GarantieType.HorsGarantie && (
                                                <p>Des frais d'enlèvement seront facturés. Un devis sera communiqué pour acceptation avant enlèvement.</p>
                                            )}

                                        </React.Fragment>
                                    )}

                                    {/* Par fournisseur */}
                                    {enlevement === '1' && (
                                        <React.Fragment>


                                        </React.Fragment>
                                    )}



                                    {/* Adresse de retour, celle de la condition SAV */}
                                    {enlevement !== '' && (
                                        <React.Fragment>

                                            <AdresseForm
                                                label={"Adresse de retour"}
                                                mode={AdresseFormModes.Basique}
                                                adresse={adresseRetour}
                                                onChange={(addr, addrStr) => this.handleChange({ target: { name: ReclamationQualificationDetailCodes.AdresseRetour, value: addrStr } })}
                                            />

                                        </React.Fragment>
                                    )}

                                </React.Fragment>
                            )}

                            {/* Le produit n'est pas déplaçable */}
                            {situationArticle === '1' && (
                                <React.Fragment>
                                    <p>Le SAV ne sera traité qu'après validation de l'action à mener</p>

                                    <div className={classes.row}>
                                        <FormControl required className={classes.formControl}>
                                            <FormLabel>{actionLabel}</FormLabel>
                                            <RadioGroup
                                                name={ReclamationQualificationDetailCodes.ActionAMener}
                                                className={classes.group}
                                                value={actionAMener}
                                                onChange={this.handleChange}
                                            >
                                                {actions.map((reponse, index) => (
                                                    <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} />
                                                ))}
                                            </RadioGroup>
                                        </FormControl>
                                    </div>

                                </React.Fragment>
                            )}

                        </React.Fragment>
                    )}


                    {/* Autre */}
                    {localisationProduit === '3' && (

                        <TextField
                            name={ReclamationQualificationDetailCodes.LocalisationProduitAutreCommentaire}
                            label={"Commentaire"}
                            value={localisationProduitAutreCommentaire}
                            onChange={this.handleChange}
                            fullWidth
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true
                            }}
                            placeholder={"Merci de préciser ..."}
                            required
                        />
                    )}




                </AccordionDetails>
            </Accordion>



        );
    }

}


LocalisationProduit.propTypes = {
    reclamation: PropTypes.object,
    name: PropTypes.string.isRequired,
    garantie: PropTypes.number,
    adresseLivraison: PropTypes.object,
    adresseRetour: PropTypes.object,
};

LocalisationProduit.defaultProps = {
    garantie: GarantieType.SousGarantieApresUtilisation
};

export default withStyles(styles)(LocalisationProduit);